import {Controller} from "stimulus"

export default class extends Controller {
  static targets = []

  initialize() {
    super.initialize();
  }

  connect(){
    this.setupDropify();
  }

  setupDropify() {
    $("#notification-image-picker").dropify({
      messages: {
        'default': 'Drag and drop or click',
        'replace': 'Drag and drop or click',
        'remove': 'Remove',
        'error': 'Oops, something wrong appended.'
      },
      error: {
        'fileSize': 'The file size is too big (1M max).'
      }
    });
  }

  completeSetup(event) {
    event.preventDefault();
    $("#campaign-form").closest('form').submit();
  }

  titleUpdate(event) {
    document.querySelector('#push-title').textContent = event.currentTarget.value
  }

  descriptionUpdate(event) {
    document.querySelector('#push-description').textContent = event.currentTarget.value
  }

  imageUpdate(event) {
    const file = event.currentTarget.files[0];
    const logo = document.querySelector("#push-logo");
    logo.querySelector('img').setAttribute('src', URL.createObjectURL(file));
  }

  discardHandler(event) {
    const url = new URL(window.location.href);
    url.searchParams.delete('segment');
    window.history.replaceState({}, '', url.toString());
    document.querySelector("#segment_select").value = "";
    event.currentTarget.setAttribute("disabled", "true");
  }

  enableDiscard(event) {
    document.querySelector("#discard-button").removeAttribute("disabled");
  }

}
